
import barba from '@barba/core';
import anime from 'animejs';

export default class{

	constructor(){
        barba.hooks.once((data) => {
            this.init()
        })
        barba.hooks.enter((data) => {
            this.init()
        });
    }
    init (){
        const heroCatchPC = document.querySelectorAll("#hero--catch__pc .st0")
        if(heroCatchPC){
            heroCatchPC.forEach(function (el) {
                el.style.filter = 'blur(5px)';
                el.style.opacity = '0';
            });
            setTimeout(function(){
                anime({
                    targets: heroCatchPC,
                    filter: 'blur(0px)',
                    opacity: 1,
                    duration: 3000,
                    easing: 'easeInQuart',
                  });
            },1000)
        }
        const heroCatchSP = document.querySelectorAll("#hero--catch__sp .st0")
        if(heroCatchSP){
            heroCatchSP.forEach(function (el) {
                el.style.filter = 'blur(5px)';
                el.style.opacity = '0';
            });
            setTimeout(function(){
                anime({
                    targets: heroCatchSP,
                    filter: 'blur(0px)',
                    opacity: 1,
                    duration: 3000,
                    easing: 'easeInQuart',
                  });
            },1000)
        }
    }
}